import { createAction } from "@reduxjs/toolkit"
import { SystemError } from "../../core/error"
import { User } from "../../models/user"

export const getCurrentUserProcess = createAction("users/getCurrentUserProcess")
export const getCurrentUserSuccess = createAction<User>("users/getCurrentUserSuccess")
export const getCurrentUserFailed = createAction<SystemError>("users/getCurrentUserFailed")
